import React from "react";
import PropTypes from "prop-types";
import DeleteSweepTwoToneIcon from '@mui/icons-material/DeleteSweepTwoTone';
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@mui/material";
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import InfoTwoTone from '@mui/icons-material/InfoTwoTone';

const KanbanColumn = (props) => {
  const { t } = useTranslation();

  return (
    <div className="react-kanban-column">
      {props.id == 0 && (
        <div className={"kanban is-column is-column-header is-column-" + props.columnName}
        >
           <div style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between', alignContent: "center" }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
            
              <DeleteSweepTwoToneIcon />
              <IconButton
                size="small"
                style={{padding: '0px'}}
                onClick={() => {
                  props.toggleQuestionableColumn();
                }}
              >
                {props.openQuestionableColumn ?
                  (<ChevronLeftRoundedIcon />) :
                  (<ChevronRightRoundedIcon />)
                }
              </IconButton>
             
              <Tooltip title={t("kanban.explainers." + props.columnName)}>
                <InfoTwoTone
                    fontSize="small"
                    style={{marginTop: "1px"}}
                    className={"color color-dark-gray"}
                />
              </Tooltip>
           </div>
            <span
              className={"tag color color-white"}
              style={{ textAlign: 'center', fontWeight: '700', marginRight: '6px', backgroundColor: "#575760" }}>
              {props.candidates}
            </span>
          </div>
        </div>
      )}
      {props.id > 0 && (
        <div className={"kanban is-column is-column-header is-column-" + props.columnName}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between"}}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {t("campaign.columns." + props.title)}
          
                <Tooltip title={t("kanban.explainers." + props.columnName)}>
                  <InfoTwoTone
                      fontSize="small"
                      style={{marginTop: "1px", marginLeft: "2px"}}
                      className={"color color-dark-gray"}
                  />
                </Tooltip>
             </div>
              <span
                className={"tag color color-white"}
                style={{ textAlign: 'center', fontWeight: '700', backgroundColor: "#575760" }}>
                {props.candidates}
              </span>
               
          </div>
        </div>
      )}
    </div>
  );
}

KanbanColumn.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  columnName: PropTypes.string,
  toggleQuestionableColumn: PropTypes.func,
  openQuestionableColumn: PropTypes.bool,
  candidates: PropTypes.number,
  infoText: PropTypes.string
};

export default KanbanColumn;